// extracted by css-extract-rspack-plugin
export default {"surveyItem":"survey-item--SJvjgcdM4pUm3A3m","delimiter":"delimiter--D6OxCY3xfwgJ8xV_"};